enum MessageType {
    NONE = "NONE",
    TECH = "TECH",
    COOP = "COOP",
    SUPPORT = "SUPPORT",
    QUESTION = "QUESTION"

}

interface Message{
    id: string | null;
    content: string;
    topic: MessageType;
    email: string;
    fullname: string;

}

export {MessageType}
export type {Message}